import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=22197480&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=22197480&prod&lang=scss"
import style1 from "./Register.vue?vue&type=style&index=1&id=22197480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22197480",
  null
  
)

export default component.exports